import { Component, OnInit } from '@angular/core';
import { LibellesService } from 'src/app/core/libelles.service';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { InputComponent } from '../input/input.component';
import { FiltreService } from '../../filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-checkbox-input',
  templateUrl: './checkbox-input.component.html',
  styleUrls: ['../input/input.component.css']
})
export class CheckboxInputComponent extends InputComponent implements OnInit {
  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
    super(formulaireService, libelleService, filtreService, modeRenduService);
  }


}
